module.exports = __webpack_public_path__ + "static/media/Truss-Beverages-Privacy-Policy---FR_June-2020.bcbc3308.pdf";